import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable()
export class UnsavedChangesService {
	public hasChanges$: Observable<boolean>;
	private hasChanges: Subject<boolean>;

	public constructor() {
		this.hasChanges = new BehaviorSubject(false);
		this.hasChanges$ = this.hasChanges.asObservable().pipe(distinctUntilChanged());
	}

	public setHasChanges(hasChanges: boolean) {
		this.hasChanges.next(hasChanges);
	}
}
